<template>
    <div class="mixFooter">
        <Above></Above>
        <Copyright></Copyright>
    </div>
</template>

<script>
import Above from './above.vue'
import Copyright from './copyright.vue'
export default {
    components:{
        Above,
        Copyright
    }
}
</script>